import { Component, OnInit, Renderer2, inject, input } from '@angular/core';

@Component({
  selector: 'app-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.scss'],
  imports: [],
})
export class LoadingOverlayComponent implements OnInit {
  private _renderer = inject(Renderer2);

  readonly inBlock = input(false);
  readonly loading = input(false);
  // Covers the app header as well. For the shell itself being replaced — a
  // sign-in or a sign-out — where the default 60px inset would leave the header
  // showing while it drops out from under the user.
  readonly overHeader = input(false);
  private isInitiated = false;

  public async ngOnInit(): Promise<void> {
    this.isInitiated = true;
    // this.renderLoadingOverlayClass(this.loading());
  }

  // private renderLoadingOverlayClass(value: boolean) {
  //   if (!this.inBlock && this.isInitiated) {
  //     const loadingOverlayBodyClass = 'loading-overlay-visible';
  //     if (value) {
  //       if (!document.body.classList.contains(loadingOverlayBodyClass)) {
  //         this._renderer.addClass(document.body, loadingOverlayBodyClass);
  //       }
  //     } else {
  //       if (document.body.classList.contains(loadingOverlayBodyClass)) {
  //         this._renderer.removeClass(document.body, loadingOverlayBodyClass);
  //       }
  //     }
  //   }
  // }
}
